module.exports = __webpack_public_path__ + "img/Pista_3416.ebe3fb2d.png";